import React from "react";
import Image from "next/image";
import { FaStar, FaUsers, FaArrowRight } from "react-icons/fa";
import { SiG2 } from "react-icons/si";
import { useRouter } from "next/router";
import CaseStudyHoverCard from "./CaseStudyHoverCard";
import { caseStudies } from "./case-studies-constants";
import { TbUsersGroup } from "react-icons/tb";
import { GrGroup } from "react-icons/gr";
import AnimatedLogos from "./AnimatedLogos";
import { BASE_ASSETS_URL } from "../../constants/constants";
export const companyLogos = [
  {
    url: `1.png`,
    name: "Angelfire",
    haveCaseStudy: true,
    companyKey: "angel-fire".toLowerCase(),
  },
  {
    url: `2.png`,
    name: "G & H Transport",
    haveCaseStudy: true,
    companyKey: "g-h-transport".toLowerCase(),
  },

  {
    url: `3.png`,
    name: "Beaver",
    haveCaseStudy: true,
    companyKey: "beaver".toLowerCase(),
  },
  {
    url: `4.png`,
    name: "Shine Above",
    haveCaseStudy: true,
    companyKey: "shine-above".toLowerCase(),
  },
  {
    url: `5.png`,
    name: "Harry Corry",
    haveCaseStudy: true,
    companyKey: "harry-corry-ltd".toLowerCase(),
  },
  {
    url: `6.png`,
    name: "Rethink",
    haveCaseStudy: true,
    companyKey: "rethink".toLowerCase(),
  },

  {
    url: `7.png`,
    name: "Mancosa",
    haveCaseStudy: true,
    companyKey: "mancosa".toLowerCase(),
  },
  {
    url: `8.png`,
    name: "Aging Comfort",
    haveCaseStudy: true,
    companyKey: "aging-comfort".toLowerCase(),
  },
];

const CustomersComponent = () => {
  const [hoveredIdx, setHoveredIdx] = React.useState(null);
  const router = useRouter();

  const handleLogoClick = (companyKey) => {
    router.push(`/signature/case-studies/${companyKey}`);
  };

  return (
    <div className=" mx-auto px-4 sm:px-6 lg:px-8 py-2 w-full  text-white">
      <div className="text-center mb-8 ">
        <h2 className="text-lg font-semibold tracking-wide uppercase mb-2">
          Trusted by Leading Brands Across Healthcare, Education, Retail, and
          Logistics
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-2">
          <div className="flex items-center gap-2  text-sm">
            <Image
              src={`${BASE_ASSETS_URL}/case-studies/capterra-logo.png`}
              alt="Capterra Logo"
              width={20}
              height={20}
              className="rounded-full"
            />
            <span className="flex items-center ">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className="text-yellow-400 text-sm" />
              ))}
            </span>
            <span className="font-medium ml-1">4.9 rating</span>
          </div>
          <div className="">|</div>
          <div className="flex items-center gap-2 text-sm">
            <GrGroup className="text-xl " />
            <span className="font-medium">50k+ businesses</span>
          </div>
        </div>
      </div>

      {/* New Animated Logos Component */}
      <AnimatedLogos />

      {/* Original Grid Layout (Commented) */}
      {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 items-center justify-center mx-auto relative w-fit gap-x-4 md:gap-x-20">
        {companyLogos.map((logo, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center relative group"
            onMouseEnter={() => setHoveredIdx(idx)}
            onMouseLeave={() => setHoveredIdx(null)}
          >
            <div
              className="cursor-pointer"
              onClick={() => handleLogoClick(logo.companyKey)}
            >
              <Image
                src={logo.url}
                alt={logo.name}
                className="object-contain mb-2"
                width={100}
                height={10}
              />
            </div>
            {logo.haveCaseStudy && (
              <div
                className="absolute -bottom-2 right-[20%] w-fit flex items-center cursor-pointer"
                onClick={() => handleLogoClick(logo.companyKey)}
              >
                <button className="bg-blue-50 text-blue-600 text-[8px] px-2 py-0.5 rounded-full flex items-center gap-1 group-hover:pr-1 transition-all duration-300">
                  Case study
                </button>
                <div className="bg-blue-50 p-0.5 rounded-full transform translate-x-[-100%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300 ml-1">
                  <FaArrowRight className="text-[8px] text-blue-600" />
                </div>
              </div>
            )}
            {hoveredIdx === idx && (
              <div
                className={`absolute z-50 left-1/2 -translate-x-1/2 -top-[380px]`}
              >
                <CaseStudyHoverCard
                  {...generateTestimonials(logo.companyKey)}
                />
              </div>
            )}
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default CustomersComponent;
